import { render } from "./plan-b.vue?vue&type=template&id=ea38905c"
import script from "./plan-b.vue?vue&type=script&lang=js"
export * from "./plan-b.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__